<template>
	<div class="innerBox">
		<h2>Supplier Voucher Details</h2>
		<div class="row mt-2" >
			<div class="col-sm-6 col-md-3 mt-2">
				<button class="btn btn-primary" @click="$router.push({name : 'SupplierVoucher'})"> < Back</button>
			</div>
			<div class="col-sm-6 offset-md-7 col-md-2">
				<button class="w-100 btn btn-info" @click="printVoucher()">Print Voucher</button>
			</div>
		</div>
		<!-- <div class="outerBox" style="margin: 20px 0">
			<div class="innerBox">
				<div class="row">
					<div class="col-6">
						<h4>Kode Voucher</h4>
						<p>{{data.sv_code}}</p>
					</div>
					<div class="col-6">
						<h4>Nama Supplier</h4>
						<p>{{data.supplier}}</p>
					</div>
					<div class="col-6">
						<h4>Tanggal Pembayaran</h4>
						<p>{{data.payment_date ? moment(data.payment_date).format('MMM DD, YYYY') : '-'}}</p>
					</div>
					<div class="col-6">
						<h4>Total Pengeluaran</h4>
						<p>Rp. {{numberWithCommas(total)}}</p>
					</div>
					<div class="col-6">
						<h4>References Number</h4>
						<p>{{data.references_no ? data.references_no : '-'}}</p>
					</div>
				</div>
			</div>
		</div> -->
		<!-- {{data}} -->
		<div class="row">
			<div class="col-md-3 col-12" v-if="data.references_img">
				<button class="btn mt-4" @click="showImage = !showImage" :class="{'btn-primary' : !showImage , 'btn-danger' : showImage}">{{!showImage ? 'Tampilkan' : 'Tutup'}} Faktur Pembayaran</button>
			</div>
			<div class="col-md-9 col-12 p-10 border border-secondary rounded text-center" v-if="showImage">
				<img :src="urlStart + '/' + data.references_img" style="height:auto;width:100%" />
			</div>
		</div>
		
		
		<!-- {{detailData}} -->

		<!-- <table class="table text-center mt-4">
			<thead class="thead-dark">
				<th>No.</th>
				<th>Work Order Code</th>
				<th>Nomor Polisi</th>
				<th>Nama Sparepart</th>
				<th>Dekrispsi</th>
				<th>Harga</th>
			</thead>
			<tbody v-for="(desc , index ) in detailData">
				<td>{{index + 1}}.</td>
				<td>{{desc.work_order_code ? desc.work_order_code : '-'}}</td>
				<td>{{desc.nomor_polisi ? desc.nomor_polisi : '-'}}</td>
				<td>{{desc.name}}</td>
				<td>{{desc.description}}</td>
				<td>Rp. {{numberWithCommas(desc.amount)}}</td>
			</tbody>
		</table> -->


		<printVoucher 
			class="mt-3 mb-3 p-10"
			v-if="print"
			:detailData="detailData"
			:data="data"
			:total="total"
			id="print"
		/>
	</div>
</template>

<script>
import moment from 'moment'
import env from '@/env'

import printVoucher from './printVoucher.vue'
export default {
	components : {
		printVoucher
	},
	data () {
		return {
			data : null,
			moment,
			urlStart : env.baseImage,
			showImage : false,
			detailData : null,
			total : 0,
			print : true
		}
	},	
	mounted() {
		this.data = JSON.parse(this.$route.params.data)

		this.loadData()
	},
	methods : {
		loadData () {
			this.$http.get('/api/v1/treasury/supplier-voucher/' + this.data.sv_code)
			.then((resp) => {
				this.detailData = resp.data.data

				for(var i = 0 ; i < this.detailData.length ; i++) {
					this.total += parseFloat(this.detailData[i].amount)
				}
			})
			.catch((err) => {
				this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong. Please Try Again later.'])
				console.log(err)
			})
		},
		printVoucher () {
			this.$htmlToPaper('print');
		}
	}
}
</script>